<template>
	<div class="site-works">
		<vx-card>
			<div class="tab-text ">
				<vs-table max-items="5" pagination :data="answers">
					<template slot="thead">
						<vs-th
							v-for="fil in field"
							:class="{
								'justify-center':
									fil.align && fil.align === 'center'
							}"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-if="fil.field === 'name'"
								>
									{{ tr.name }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-if="fil.field === 'variables'"
								>
									{{ tr.variables }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-if="fil.field === 'subject'"
								>
									{{ tr.subject || '—' }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-if="fil.field === 'content'"
								>
									<div
										class="auto-answer-content"
										v-html="htmlToPlainText(tr.content)"
									></div>
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
									v-if="fil.field === 'actions'"
								>
									<div class="flex justify-center">
										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="
												editModel = JSON.parse(
													JSON.stringify(tr)
												);
												activePromptEdit = true;
											"
											icon="edit"
										>
											<feather-icon
												icon="EditIcon"
											></feather-icon>
										</vs-custom-button>
									</div>
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			:active.sync="activePromptEdit"
			:title="$t('changeAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
			class="template-popup"
			@cancel="date = ''"
			@accept="editAnswer"
		>
			<div class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">{{ $t("name") }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.name"
						name="editModel.name"
						readonly
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('editModel.name')">{{
						$t("fieldFilledIncorrect")
					}}</span
					><br />
				</span>
			</div>
			<div class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">{{ $t("variables") }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.variables"
						name="editModel.variables"
						readonly
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('editModel.variables')">{{
						$t("fieldFilledIncorrect")
					}}</span
					><br />
				</span>
			</div>
			<div v-if="deletionRemindersOnly" class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">{{ $t("emailSubject") }}</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.subject"
						name="editModel.subject"
						:placeholder="$t('emailSubjectPlaceholder')"
					/>
				</div>
			</div>
			<div class="con-exemple-prompt mb-3">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">{{
						$t("responseText")
					}}</label>
					<div class="vs-con-input"></div>
					<TextEditor
						v-model="editModel.content"
						name="content"
						v-validate="'required|min:3'"
						@input="resetValidations"
					/>
				</div>
				<span class="text-danger text-sm">{{
					errors.first("content")
				}}</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import TextEditor from "@/components/text-editor/TextEditor.vue";
import notifier from "../../mixins/notifier";
export default {
	name: "SiteAutoAnswers",
	mixins: [notifier],
	components: {
		TextEditor,
	},
	data() {
		return {
			answers: [],
			activePromptEdit: false,
			popupActiv: false,
			editModel: {}
		};
	},
	props: {
		model: { required: true },
		validate: { required: true, type: Boolean },
		deletionRemindersOnly: {
			type: Boolean,
			default: false
		}
	},
	computed: {},
	methods: {
		editedContent(content) {
			return content.length > 150
				? content.substr(0, 150) + "..."
				: content;
		},
		async editAnswer(id) {
			try {
				this.$validator.resume();
				let validator = await this.$validator.validateAll();
				this.$validator.pause();

				if (!validator) return (this.activePromptEdit = true);
				let formData = {
					content: this.editModel.content
				};
				if (this.deletionRemindersOnly) {
					formData.subject = this.editModel.subject || '';
				}
				await this.$http.post(
					`/admin/website/update-answer/${this.editModel.id}`,
					formData
				);

				this.notifySuccess(this.$t("changedSuccessfully"));
				this.editModel = {};
				this.activePromptEdit = false;
				this.getAnswers();
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		resetValidations(val) {
			this.$validator.reset();
		},

		htmlToPlainText(html) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");

			try {
				const extractText = node => {
					let text = "";

					if (node.nodeType === Node.TEXT_NODE) {
						text += node.textContent;
					} else if (node.nodeType === Node.ELEMENT_NODE) {
						for (const childNode of node.childNodes) {
							text += extractText(childNode);
						}
					}

					return text;
				};

        const content = extractText(doc.body)
        return this.editedContent(content)
			} catch (err) {
				console.error(err);
				return html;
			}
		},

		filterAnswers(answers) {
			if (this.deletionRemindersOnly) {
				return answers.filter(
					item => item.slug && item.slug.startsWith('deletion_reminder')
				);
			}

			return answers.filter(
				item => !item.slug || !item.slug.startsWith('deletion_reminder')
			);
		},
		async getAnswers() {
			try {
				const response = (
					await this.$http.get(
						`/admin/website/get-answers?site_id=${this.model.id}`
					)
				).data.data;
				this.answers = this.filterAnswers(response);
			} catch (e) {
				this.notifyError(e.message);
			}
		}
	},
	async mounted() {
		await this.getAnswers();
	},
	created() {
		this.field = [
			{
				field: "name",
				title: `${this.$t("name")}`,
				align: "start"
			},
			{
				field: "variables",
				title: `${this.$t("variablesList")}`,
				align: "start"
			},
		];

		if (this.deletionRemindersOnly) {
			this.field.push({
				field: "subject",
				title: `${this.$t("emailSubject")}`,
				align: "start"
			});
		}

		this.field.push(
			{
				field: "content",
				title: `${this.$t("responseText")}`,
				align: "start"
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: "center"
			}
		);
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";
@import "../../assets/scss/vuexy/functions.scss";

.template-popup {
	.vs-dialog {
		width: 100%;
		max-width: 800px;
	}
	.vs-component {
		.tox-tinymce {
			height: 400px !important;
		}
	}
}
.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}
	.vs-button {
		border-left: 0;
	}
	.vx-input-group-append {
		align-items: flex-end;
	}
	.vs-input {
		width: 100%;
		textarea {
			resize: none;
		}
	}
}
.vs-table {
	thead {
		th:nth-child(2) {
			width: 30%;
		}
	}
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}
.con-vs-tabs .con-slot-tabs {
	overflow: visible;
}

.auto-answer-content {
  min-width: 300px;
	// display: -webkit-box;
	// -webkit-line-clamp: 3;
	// -webkit-box-orient: vertical;
	// overflow: hidden;
	// text-overflow: ellipsis;
	// word-break: break-all;
}
</style>
